module.exports = [{"id":"canada","name":"Canada"},{"id":"us","name":"United States"},{"id":"denmark","name":"Denmark"},{"id":"france","name":"France"},{"id":"germany","name":"Germany"},{"id":"ireland","name":"Ireland"},{"id":"italy","name":"Italy"},{"id":"netherlands","name":"Netherlands"},{"id":"norway","name":"Norway"},{"id":"spain","name":"Spain"},{"id":"sweden","name":"Sweden"},{"id":"switzerland","name":"Switzerland"}]


//////////////////
// WEBPACK FOOTER
// ./src/components/app-demo/data/locations.json
// module id = dkXN
// module chunks = 12